import styled from 'styled-components';

const UploadInputLabel = styled.label`
  cursor: pointer;
  cursor: ${({ enabled }) => (enabled ? 'pointer' : 'auto')};
  color: ${({ enabled }) => (enabled ? '#354ea1' : '#b3b3b3')};
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: underline;
`;

export default UploadInputLabel;
